import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import api from '../../services/api';

const NewsletterSignup = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await api.post('/subscribe', values);
      if (response.data.success) {
        message.success('Thank you for subscribing!');
        form.resetFields();
      } else {
        message.error(response.data.message || 'Subscription failed');
      }
    } catch (error) {
      message.error(error.response?.data?.message || 'Subscription failed');
    } finally {
      setLoading(false);
    }
  };

  return (
       <section
      style={{
        position: 'relative',
        padding: '0px 0',
        color: '#fff',
        textAlign: 'center',
        backgroundImage: 'url("https://snmtechnologies.in/startup/img/sbg1.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
       <div
        style={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgb(60 76 76 / 60%)',
          zIndex: 1
        }}
      ></div>
    <div className="p-top-50 p-bottom-50 subscribe--five gradient-overlay">
      <div className="container content_above">
        <div className="row align-items-center">
    
          <div className="col-lg-12" style={{ position: 'relative', zIndex: 2 }}>
       
        <h2 style={{color:'#fff'}}>Subscribe To Our Newsletter</h2>
        <p>Subscribe to get update and information. Don't worry, we won't send spam!</p>

       
         <Form form={form} onFinish={onFinish} className="subscribe-form-two">
              <div>
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: 'Please input your email!' },
                    { type: 'email', message: 'Please enter a valid email!' }
                  ]}
                >
                  <Input 
                    placeholder="Enter your email address" 
                    aria-label="Email"
                    className="form-control"
                  />
                </Form.Item>
                <Button 
                  htmlType="submit" 
                  style={{padding:'0px 18px 10px 18px'}}
                  className="btn btn-primary"
                  loading={loading}
                >
                  Subscribe Now
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
     </section>
  );
};

export default NewsletterSignup;